import { type FlowBlockType } from 'flow-schema';
import { type Money } from 'notable-common';
import { z } from 'zod';

export interface LineItemActionUnit {
  actionUnitName: string;
  quantity: number;
  usageDescription: string;
  totalCost: Money;
  unitCostDescription: string;
  llmModel?: string | null;
}

export interface CostEstimateResponseLineItem {
  id: string;
  blockType: FlowBlockType;
  blockName: string;
  totalCost: Money;
  actionUnits: LineItemActionUnit[];
  subFlow?: CostEstimateResponse;
}

export interface CostEstimateResponse {
  flowName: string;
  flowDescription: string | null;
  totalCost: Money;
  lineItems: CostEstimateResponseLineItem[];
}

export const CostEstimateRequestParamsSchema = z.object({
  quantityOverrideLineItems: z
    .array(
      z.object({
        blockId: z.uuid(),
        actionUnitName: z.string(),
        quantity: z.number(),
      })
    )
    .optional(),
});

export type CostEstimateRequestParams = z.infer<typeof CostEstimateRequestParamsSchema>;
